import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { BackstageLoggerDefaultArgs } from '../../../constants';
import * as D from '../../../deps';
import { withCuratorButtonControls } from '../../common/CuratorButtonControls';

export const CuratorSidebarButtons = props => {
  const {
    curatorPandoraId,
    isPaused,
    isCurrentlyPlayingContent,
    hasPlayableContent,
    playOnClick,
    pauseOnClick,
    onShareClick,
  } = props;

  const integrationData = {
    ...BackstageLoggerDefaultArgs.controlBar,
    curatorPandoraId,
  };

  return (
    <D.AppContextIntegrationData data={integrationData}>
      <D.ButtonRowWithLogger
        playOnClick={!isCurrentlyPlayingContent || isPaused ? playOnClick : noop}
        pauseOnClick={isCurrentlyPlayingContent && !isPaused ? pauseOnClick : noop}
        disabledButtons={!hasPlayableContent ? [D.ButtonRowType.PLAY] : []}
        shareOnClick={onShareClick}
        isSidebar={true}
        hiddenButtons={[D.ButtonRowType.SHARE]}
        buttonTextType={D.ButtonTextType.PLAY}
      />
    </D.AppContextIntegrationData>
  );
};

CuratorSidebarButtons.propTypes = {
  playablePandoraId: PropTypes.string,
  curatorPandoraId: PropTypes.string,
  hasPlayableContent: PropTypes.bool,
  playableContentType: PropTypes.string,
  isCurrentlyPlayingContent: PropTypes.bool,
  isPaused: PropTypes.bool,
  playOnClick: PropTypes.func,
  pauseOnClick: PropTypes.func,
  onShareClick: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const isPlayableContentStation = ownProps.playableContentType === D.PandoraTypes.STATION;
  const playablePandoraId = isPlayableContentStation
    ? D.getStationIdByFactoryId(state, ownProps.playablePandoraId)
    : ownProps.playablePandoraId;
  return {
    isPaused: !D.getInDomain('playback.utils.isAudioPlaying', false)(state),
    isCurrentlyPlayingContent: D.getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      playablePandoraId,
    ),
    showPremiumAccess: D.Utils.Listener.showPremiumAccess(state),
    onDemandIsEnabled: D.Utils.Listener.hasPremiumFeatures(state),
  };
}

const enhance = compose(withCuratorButtonControls, connect(mapStateToProps));

export default enhance(CuratorSidebarButtons);
